import React, { useState } from "react";
import styles from "./Keypress.module.scss";
import PauseIcon from "components/UI/Icons/Sidecar/Pause";
import DeleteIcon from "components/UI/Icons/Delete";
import TransferIcon from "components/UI/Icons/Sidecar/Transfer";
import MergeCallIcon from "components/UI/Icons/VideoCall/MergeCall";
import ConferenceIcon from "components/UI/Icons/Sidecar/Conference";
import KeypressIcon from "components/UI/Icons/Sidecar/Keypress";
import EditIcon from "components/UI/Icons/Lines/Edit";
import { useDispatch } from "react-redux";
import { removeSidecarConfigNewTempActionList, setShowKeypressDialogue } from "redux/sidecar/sidecarSlice";
import MoveUpDown from "components/UI/Icons/Sidecar/MoveUpDown";

const KeypressActionCard = ({uuid, keyPress, drag, changesMade}:{uuid:string, keyPress:string, drag?:any, changesMade:()=>void}) => {
	const [editHover, setEditHover] = useState(false);
	const [deleteHover, setDeleteHover] = useState(false);
	const dispatch = useDispatch();
	return (
		<div className={styles.card} draggable onDragEnd={drag?.handlesort}  onDragEnter={()=>{drag?.dragEnter(drag)}} onDragStart={()=>{drag?.dragStart(drag)}}> 
			<p>
				{drag && <MoveUpDown />}
				<KeypressIcon />
				<span>Key Press</span>
			</p>
			<p>
				<span className={styles.extension}> Numpad button {keyPress}</span>
				{uuid &&
				<>
					<span className={styles.actionButton} onClick={()=>{changesMade(); dispatch(setShowKeypressDialogue({uuid:`${uuid}`, show:true, numberValue:`${keyPress}`}))}} onMouseOver={() => {setEditHover(true);}} onMouseOut={() => {setEditHover(false);}}><EditIcon color={editHover?"primary-default" : "icon-primary"}/></span>
					<span className={styles.actionButton} onClick={()=>{changesMade(); dispatch(removeSidecarConfigNewTempActionList(uuid))}} onMouseOver={() => {setDeleteHover(true);}} onMouseOut={() => {setDeleteHover(false);}}><DeleteIcon color={deleteHover?"support-danger-default" : "icon-primary"} /></span>
				</>}
			</p>
		</div>
	);
};

export default KeypressActionCard;
